module.exports = __webpack_public_path__ + "static/media/banner.65104cb5.png";